"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _digiwashComponents = require("digiwash-components");

var _useToast = _interopRequireDefault(require("./useToast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToastMessage(props) {
  let bg = "common.white";
  let TextColor = "common.black";

  if (props.options) {
    if (props.options.type === "success") {
      bg = "green.main";
      TextColor = "common.white";
    } else if (props.options.type === "danger") {
      bg = "red.light200";
      TextColor = "common.white";
    } else if (props.options.type === "warning") {
      bg = "orange.dark";
      TextColor = "common.white";
    }
  }

  let toast = (0, _useToast.default)();
  return /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    style: {
      width: "100%",
      maxWidth: 468
    },
    p: "l"
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    br: "xm",
    bg: bg,
    p: "l"
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Stack, null, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Typography, {
    color: TextColor
  }, props.message), props.options && props.options.actionText ? /*#__PURE__*/_react.default.createElement(_digiwashComponents.Stack, null, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Button, {
    onPress: () => {
      toast.hideAll();
    },
    fill: "transparent",
    textColor: "gray.light960"
  }, "\u0628\u06CC\u062E\u06CC\u0627\u0644"), /*#__PURE__*/_react.default.createElement(_digiwashComponents.Button, {
    onPress: props.options.action,
    fill: "transparent",
    textColor: "primary.main"
  }, props.options.actionText)) : null)));
}

var _default = ToastMessage;
exports.default = _default;